import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, lastValueFrom } from 'rxjs';
import { SDHttpService } from '../../Common/Routing/sd-http.service';
import { TaxRateGridService } from '../tax.rate.grid.service';
import { CommandCenterSearchModel, QcStateCount } from '../tax.rate.model';
import { Assessor } from '../../Assessor-Collector/assessor.model';
import { Collector } from '../../Assessor-Collector/collector.model';
import { HttpResponse, HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class TaxRateCommandCenterService extends TaxRateGridService {
    constructor(private sdHttp: SDHttpService, httpClient: HttpClient) {
        super(httpClient);
    }

    private _taxRateCommandCenterDataSubject = new BehaviorSubject<any>(false);

    get taxRateCommandCenterData$(): Observable<void> {
        return this._taxRateCommandCenterDataSubject.asObservable();
    }

    async loadTaxAuthorities(): Promise<void> {
        await this._loadTaxAuthorities();

        this._taxRateCommandCenterDataSubject.next(true);
    }

    async loadTaxRateAreas(): Promise<void> {
        await this._loadTaxRateAreas();

        this._taxRateCommandCenterDataSubject.next(true);
    }

    getList(searchParams: CommandCenterSearchModel): Observable<any> {
        return this.httpPost('/api/taxrate/commandcenter', searchParams);
    }

    async getPendingQcCounts(): Promise<QcStateCount[]> {
        return this.sdHttp.get('/api/TaxAuthority/GetPendingQcCountByState');
    }

    async getAssessors(stateId: number): Promise<Assessor[]> {
        return this.sdHttp.get(`/api/TaxRate/commandcenter/state/${stateId}/Assessors`);
    }

    async getCollectors(stateId: number, assessorId?: number): Promise<Collector[]> {
        let url = `/api/TaxRate/commandcenter/state/${stateId}/collectors`;

        if (assessorId) {
            url += `?assessorId=${assessorId}`;
        }

        return this.sdHttp.get(url);
    }

    async getTaxAuthoritySelections(selectionOptions: Core.TaxRateSearchModel): Promise<Core.TaxAuthorityToUpdate[]> {
        return this.sdHttp.post('/api/TaxAuthority/Selections', selectionOptions);
    }

    async getTaxAuthoritySelectionsForBulkUpdate(selectionOptions: Core.TaxRateSearchModel): Promise<Core.TaxAuthorityToUpdate[]> {
        /*
        const selections: TaxAuthorityToUpdate[] = _.map(selectionOptions.selectedTaxAuthorityIds, (taId: number) : TaxAuthorityToUpdate => {
            return {
                taxAuthorityId: taId,
                name: `TaxAuthority ${taId}`,
                code: `TA-${taId}`
            }
        });
        return Promise.resolve(selections);
        */
        return this.sdHttp.post('/api/TaxAuthority/BulkUpdate/Selections', selectionOptions);
    }

    bulkUpdate(request: Core.TaxAuthoritiesBulkUpdateRequest): Promise<void> {
        return lastValueFrom(this.httpClient.put(`/api/TaxAuthority/BulkUpdate`, request)) as Promise<any>;
    }

    exportTaxRateData(exportModel: Core.TaxRateExportModel): Promise<number> {
        return this.sdHttp.post('/api/taxrateservice/export', exportModel);
    }

    getTaxRateDataExport(longRunningProcessId: number): Observable<HttpResponse<Blob>> {
        const options = {
            observe: 'response',
            responseType: 'blob'
        };

        return this.httpGet(`/api/taxrateservice/export/${longRunningProcessId}`, options);
    }

    retryProcessingTaxAuthorities(taxAuthorityIds: number[]): Promise<void> {
        return this.sdHttp.post('/api/TaxAuthority/retryProcessing', taxAuthorityIds);
    }

    private async _loadTaxAuthorities(): Promise<void> {
        // this.isInitialized = false;
        // const data =  await this.getStub();
        // this.taxAuthorities = data.taxAuthorities;
        // this.taxRateAreas = data.taxRateAreas;
        // this.isInitialized = true;
    }

    private async _loadTaxRateAreas(): Promise<void> {
        // this.isInitialized = false;
        // const data =  await this.getStub();
        // this.taxAuthorities = data.taxAuthorities;
        // this.taxRateAreas = data.taxRateAreas;
        // this.isInitialized = true;
    }
}
